import React from 'react';
import type { KaliaCalendarConfig } from './types';

type Props = {
    timeSlots: string[];
    config: KaliaCalendarConfig;
};

const TIME_LABEL_OFFSET = 9;

function KaliaCalendarTimeColumn({ timeSlots, config }: Props) {
    return (
        <div className='sticky left-0 z-30 bg-white' style={{ width: 56 }}>
            {/* Spacer so the first label isn't hidden behind the sticky header */}
            <div className='border-r border-gray-300' style={{ height: TIME_LABEL_OFFSET }} />
            {timeSlots.map((slot) => (
                <div
                    key={slot}
                    className='relative border-r border-gray-300 text-right pr-2'
                    style={{ height: config.slotHeight }}
                >
                    <span className='absolute -top-[9px] right-2 text-[11px] text-gray-500 font-medium select-none leading-none'>
                        {slot}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default React.memo(KaliaCalendarTimeColumn);
